module.exports = __webpack_public_path__ + "img/refresh.2c58c79f.svg";